// extracted by mini-css-extract-plugin
export default {"list_of_topics":"specificStyle_list_of_topics__bNI33"};